<template>
	<div class="gantt-sheet-view-updater-outter">
		<div class="updater-header">
			<div class="title">
				<canvas-helper-indicator
					class="indicator"
					:record="record"
					:sheetView="sheetView"
					:clickable="false"
				></canvas-helper-indicator>
				<div class="header-spacer">
					<span v-if="isValidToPlot">Plotted on&nbsp;</span>
					<span>{{ sheetView.title }}</span>
					<span v-if="invalidTitleMessage">&nbsp;- {{ invalidTitleMessage }}</span>
					<span v-else-if="!isValidToPlot">&nbsp;- address the highlighted fields below to plot on this gantt</span>
				</div>
			</div>
			<div class="grid">
				<div class="header"></div>
				<div class="header">Field Used</div>
				<div class="header last">Project Data on Timeline</div>
				<div class="cell describe">Begin date</div>
				<div class="cell pickers">
					<timeline-header-datefield-picker 
						:class="{
							warn: !sheetViewValid.startDateField
						}"
						:sheetView="sheetView"
						dateName="startDate"
						theme="cell"
					></timeline-header-datefield-picker>
				</div>
				<div class="cell">
					<dynamic-record-field
						v-if="startDateFieldGUID"
						:class="{
							warn: startDateWarn
						}"
						:sheetView="sheetView"
						:record="record"
						:fieldGUID="startDateFieldGUID"
					></dynamic-record-field>
					<div
						v-else
						class="empty"
					>
						--
					</div>
				</div>
				<div class="cell describe">End date</div>
				<div class="cell pickers">
					<timeline-header-datefield-picker
						:class="{
							warn: !sheetViewValid.endDateField
						}"
						:sheetView="sheetView"
						dateName="endDate"
						theme="cell"
					></timeline-header-datefield-picker>
				</div>
				<div class="cell">
					<dynamic-record-field
						v-if="endDateFieldGUID"
						:class="{
							warn: endDateWarn
						}"
						:sheetView="sheetView"
						:record="record"
						:fieldGUID="endDateFieldGUID"
					></dynamic-record-field>
					<div
						v-else
						class="empty"
					>
						--
					</div>
				</div>
			</div>
			<div
				v-if="messageAreaText"
				class="message-area"
			>
				{{ messageAreaText }}
			</div>
		</div>
	</div>
</template>
<script>

import CanvasHelperIndicator from 'vue/sheet-views/data-table/canvas-helper-indicator';

import TimelineGroupSelector from 'vue/sheet-views/timeline/timeline-group-selector';
import TimelineHeaderDatefieldPicker from 'vue/sheet-views/timeline/header/timeline-header-datefield-picker.vue';

import DynamicRecordField from 'vue/sheet-views/common/fields/dynamic-record-field.vue'

export default {
	name:'gantt-sheet-view-updater-outter',
	data(){
		return{
		};
	},
	components:{
		CanvasHelperIndicator,
		TimelineGroupSelector,
		TimelineHeaderDatefieldPicker,
		DynamicRecordField,
	},
	props:{
		record:{
			required: true,
			type: Object,
		},
		sheetView:{
			required: true,
			type: Object,
		},
	},
	inject: ['sheetGlobalState'],
	mounted(){
		// const focusable = this.$el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		// if(focusable[0] && focusable[0].focus){
		// 	focusable[0].focus();
		// }
	},
	computed:{
		schema(){
			return this.sheetView.sheetViewGroup.dataStore.meta.schema;
		},
		recordGUID(){
			return this.record.$internals.metaProperties.meta.guid;
		},
		sheetViewGUID(){
			return this.sheetView.$internals.metaProperties.meta.guid;
		},
		sheetViewValid(){
			return this.sheetView.ganttIsValid();
		},
		sheetViewCanPlotRecord(){
			return this.sheetView.ganttCanPlotRecord(this.record, this.sheetGlobalState.dataStoreRecordsByLevels);
		},
		startDateWarn(){
			return !this.sheetViewCanPlotRecord.startDateRecordValue || !this.sheetViewCanPlotRecord.dateOrder;
		},
		endDateWarn(){
			return !this.sheetViewCanPlotRecord.endDateRecordValue || !this.sheetViewCanPlotRecord.dateOrder;
		},
		sheetViewHierarchyInfo(){
			return this.sheetView.getOrCreateDisplayHierarchy();
		},
		sheetViewHierarchiesList(){
			const vcSelf = this;
			const rootLevel = this.sheetViewHierarchyInfo.rootLevel;
			const maxDepth = this.sheetViewHierarchyInfo.rootLevel + this.sheetViewHierarchyInfo.depth;
			return vcSelf.sheetGlobalState.dataStoreRecordsByLevels.filter(function onlyLevelsShownOnSheetView(levelStruct, levelIndex){
				return levelIndex >= rootLevel && levelIndex <= maxDepth;
			}).map(function levelsToListOfNames(levelStruct){
				return levelStruct.name;
			});
		},
		invalidTitleMessage(){
			if(!this.sheetViewCanPlotRecord.includesLevel){
				return `this gantt is only plotting Visor items: ${this.sheetViewHierarchiesList.join(", ")}`;
			}
			return ``;
		},
		messageAreaText(){
			if(!this.sheetViewCanPlotRecord.dateOrder){
				return `"End date" cannot be before "Begin date"`;
			}
			return ``;
		},
		isValidToPlot(){
			return this.sheetViewCanPlotRecord.isValid;
		},
		ganttIndicatorTheme(){
			const vcSelf = this;
			if(!this.isValidToPlot){
				return 'warn';
			}
			return '';
		},
		startDateFieldGUID(){
			if(!!this.schema.fields[this.sheetView.properties.fields.startDate]){
				return this.sheetView.properties.fields.startDate;
			}
			return null;
		},
		endDateFieldGUID(){
			if(!!this.schema.fields[this.sheetView.properties.fields.endDate]){
				return this.sheetView.properties.fields.endDate;
			}
			return null;
		},
	},
	methods:{
	},
}
</script>

<style scoped lang="scss">

.gantt-sheet-view-updater-outter{
	width: 100%;

	.updater-header{

		margin-bottom: 36px;

		.indicator{
			padding-left: 6px;			
		}

		.header-spacer{
			margin-left: 6px;
		}
		
		.title{
			display: flex;
		    align-items: center;
		    padding-top: 6px;
			padding-bottom: 15px;
			background-color: $p-color-grey-100;
			font-weight: 600;
			font-size: 13px;
			line-height: 20px;
			letter-spacing: 0.01em;

		}

		.grid{
			display: grid;
			align-items: center;
			grid-gap: 0;
			grid-template-columns: 128px 246px 246px;
			grid-template-rows: 27px 40px 40px;

			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 14px;
			line-height: 20px;
			letter-spacing: 0.15px;
			color: $p-color-grey-600;

			.header{
				font-family: $rvFontFamily;
				font-weight: 600;
				font-size: 13px;
				line-height: 20px;
				letter-spacing: 0.01em;
				color: $p-color-grey-400;
				background-color: $p-color-grey-100;

				height: 100%;
				padding-left: 12px;
				border-right: 1px solid $p-color-grey-200;
				border-bottom: 2px solid $p-color-grey-300;

				&.last{
					border-right: none;
				}
			}

			.cell{
				height: 100%;
				box-sizing: border-box;
				border-right: 1px solid $p-color-grey-200;
				border-bottom: 1px solid $p-color-grey-200;

				&.describe{
					font-family: $rvFontFamily;
					font-weight: 500;
					font-size: 14px;
					line-height: 20px;
					letter-spacing: 0.15px;
					color: $p-color-grey-500;
					padding-left: 12px;
					display: flex;
					align-items: center;
				}

				&.pickers{

					display: flex;
					align-items: center;
				}

				.warn{
					box-sizing: border-box;
					border: 1px solid red;
					opacity: 1;
				}

				.empty{
					display: flex;
					align-items: center;					
					height: 100%;
					padding-left: 12px;
					color: $p-color-grey-300;
				}
			}
		}

		.message-area{
			font-family: $rvFontFamily;
			font-weight: 500;
			font-size: 13px;
			line-height: 18px;
			letter-spacing: 0.15px;
			color: $p-color-red-300;
			margin-left: 157px;
			margin-top: 12px;			
		}
	}
}

</style>
